import React from 'react';
import Create from '../../../create';

export default function BookParcel() {
  const schema = [
    {
      tabName: 'Area',
      editFields: [
        {
          label: 'Area Name',
          name: 'name',
          type: 'text',
        },
      ],
    },
  ];
  return (
    <Create return="/dashboard/areas" url={`${process.env.REACT_APP_API_SERVER}/areas`} dataID={null} schema={schema} />
  );
}
